const CLIENT_EXTENSION_SELECTOR = "pms-forgot-password-element";

const extractValue = (value) => {
  if (!value) return null;

  const match = value.match(/default=([^,}]+)/);

  return match ? match[1].trim() : value;
};

export const getClientExtensionProperty = (propertyName) => {
  const element = document.querySelector(CLIENT_EXTENSION_SELECTOR);

  if (!element) {
    return null;
  }

  return extractValue(element.getAttribute(propertyName.toLowerCase()));
};